export const environment = {
  production: false,
  baseUrl: 'https://mawared-backend.azurewebsites.net/api',
  //baseUrl: 'https://localhost:5001/api',
  secretKey: 'My$uper$ecretKey123!',
};
